import {Injectable} from '@angular/core';
import {EntityAccountTransactionListDto} from '@dto/holdings/entity-account-transaction-list.dto';
import {EntityAccountTransactionViewModel} from '../view-models/entity-account-transaction.view-model';
import {EntityAccountTransactionDto} from '@dto/holdings/entity-account-transaction.dto';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';

@Injectable({
  providedIn: 'root'
})
export class EntityAccountTransactionConverterService {

  public convert(transactionList: EntityAccountTransactionListDto): EntityAccountTransactionViewModel[] {
    const transactions = transactionList.entityAccountTransactions;
    const lowestId = Math.min(...transactions.map(transaction => transaction.id));
    return transactions.map(transaction => this.convertSingle(transaction, lowestId));
  }

  private convertSingle(transaction: EntityAccountTransactionDto, lowestId: number): EntityAccountTransactionViewModel {
    const offsetId = transaction.id - lowestId; // Offset the numeric transaction ID by the lowest ID in this set of transactions
    const transactionDate = new Date(transaction.date);
    const offsetDate = new Date(transactionDate.getTime() + offsetId); // Add the transaction's offset ID as milliseconds to differentiate this transaction from others made on the same day

    return {
      date: offsetDate,
      description: transaction.description,
      amount: new FormattedNumber(transaction.amount),
    };
  }
}
